import { AppFlow } from '../flow';

export class FetchAndHandleStartupConfiguration {
  static readonly type = '[StartupConfiguration] Fetch and handle startup configuration';
  constructor(public appFlow: AppFlow) {}
}
